// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08186aee","455":"813034f3","977":"9675fe6f"}[chunkId] + ".chunk.js";
};